import { useEffect, useRef } from 'react';

/*
 * A round magnifier shown above a finger while it draws, so the mushroom under
 * the fingertip -- and the annotation cursor, which sits above the finger -- stay
 * visible. It copies the photograph and the annotation overlay around `point`
 * (normalised) at `zoom` times their displayed size.
 */
export default function Loupe({ imageRef, overlayRef, point, left, top, size = 120, zoom = 2 }) {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas && canvas.getContext ? canvas.getContext('2d') : null;
    if (!ctx || !point) return;
    const image = imageRef.current;
    const overlay = overlayRef.current;
    const cssWidth = image ? image.getBoundingClientRect().width : 0;
    const draw = (source, sourceWidth, sourceHeight) => {
      if (!source || !sourceWidth || !sourceHeight || !cssWidth) return;
      const region = (size / zoom) * (sourceWidth / cssWidth);
      try {
        ctx.drawImage(source, point[0] * sourceWidth - region / 2, point[1] * sourceHeight - region / 2,
                      region, region, 0, 0, size, size);
      } catch {
        // not decoded yet
      }
    };
    ctx.clearRect(0, 0, size, size);
    ctx.save();
    ctx.beginPath();
    ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
    ctx.clip();
    draw(image, image?.naturalWidth, image?.naturalHeight);
    draw(overlay, overlay?.width, overlay?.height);
    ctx.strokeStyle = 'rgba(255,255,255,0.9)';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(size / 2 - 10, size / 2);
    ctx.lineTo(size / 2 + 10, size / 2);
    ctx.moveTo(size / 2, size / 2 - 10);
    ctx.lineTo(size / 2, size / 2 + 10);
    ctx.stroke();
    ctx.restore();
  });

  return (
    <canvas ref={ref} data-testid="annotation-loupe" width={size} height={size} aria-hidden="true"
            style={{ position: 'absolute', left, top, width: size, height: size, borderRadius: '50%',
                     border: '2px solid #ffffff', boxShadow: '0 2px 10px rgba(0,0,0,0.45)', pointerEvents: 'none' }} />
  );
}
